module.exports = __webpack_public_path__ + "assets/img/202108-6W.2aa9e096.png";